import { useContext } from 'react'
import { StoreContext } from 'contexts'
import { StoreInterface } from 'contexts/StoreContext'

const useStore = (): [
    StoreInterface,
    (updates: Partial<StoreInterface>) => void,
] => {
    const { store, updateStore } = useContext(StoreContext)
    return [store, updateStore]
}

export default useStore
